import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// global stylesheet
import "./assets/style/main.scss";

Vue.config.productionTip = false

// import external library
import "./plugins"
import i18n from "@/i18n";

// middleware
import "./middleware/auth";

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
